import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import { CustomButton } from '../../../../components/UI/CustomButton';
import useStyles from './styles';

interface LeaveModalProps {
  goBackPath: string;
  closeModal: () => void;
}

const LeaveModal: React.FC<LeaveModalProps> = ({ goBackPath, closeModal }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.container} data-testid="leaveModal">
      <Box className={classes.modal}>
        <CloseIcon className={classes.modalCloseBtn} onClick={closeModal} />
        <Typography variant="h3">{t('page.test.leaveTitle')}</Typography>
        <Typography className={classes.modalDescription}>
          {t('page.test.leaveDescription')}
        </Typography>
        <Box className={classes.controls}>
          <Link to={goBackPath}>
            <CustomButton color="secondary">{t('button.backToPathway')}</CustomButton>
          </Link>
          <CustomButton onClick={closeModal}>{t('button.continueTest')}</CustomButton>
        </Box>
      </Box>
    </Box>
  );
};

export default LeaveModal;
